export default "__VITE_ASSET__ANAKBsGt__"